module.exports = __webpack_public_path__ + "img/bkl2.3727356a.jpg";